import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from './../Modal';
import alarm from './../../img/icons/alarm.svg';
import OrderTabQAItem from './OrderTabQAItem';
import QACollapseItem from './QACollapseItem';
import { ordersQAReportFetch } from './../../store/orders/actions';
import UploadReportFile from './UploadReportFile';
import EditableText from '../EditableText';
import {
    STATUS_COMPLETE,
} from './../../store/orders/actions';

import {
    dataContentSectionContent,
    dataContentSectionStructure,
    dataContentSectionLanguage,
    dataContentSectionFormat,
} from './dataQACategory';

const allDataSection = {
    ...dataContentSectionContent,
    ...dataContentSectionStructure,
    ...dataContentSectionLanguage,
    ...dataContentSectionFormat,
};

const valField = {
    0: 'Yes',
    1: 'Mostly',
    2: 'Poorly',
    3: 'No',
    4: 'N/A',
};

class OrderTabQA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEdit: false,
            formData: null,
            loading: true,
            Content: null,
            Structure: null,
            Language: null,
            Format: null,
            avgOut: null,
            avgOf: null,
            avgOutPercent: null,
            comment: props.order.pregrader_recommendations,
            isGradingLow: false,
            isModalOpen: false,
            // messError: null,
        };

        this.onEdit = this.onEdit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSaveReport = this.onSaveReport.bind(this);
        this.generateTitleCategory = this.generateTitleCategory.bind(this);
        this.onUpdateComment = this.onUpdateComment.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState(state => Object.assign({}, state, {
            isModalOpen: !state.isModalOpen
        }));
    }

    parseData() {
        const formData = this.props.order.pregrader_report_form_data || [];
        const arrFormData = {};

        if (!!formData) {
            formData.forEach((item) => {
                arrFormData[item.split(':')[0]] = item.split(':');
            });
        }

        this.checkRatingString(arrFormData);
        this.calcSum(arrFormData);

        this.setState(state => ({
            formData: arrFormData,
            loading: false,
            avg: this.props.order.pregrader_assessing_avg || null,
            comment: this.props.order.pregrader_recommendations || null,
        }));
    }

    componentDidMount() {
        this.parseData();
    }

    componentDidUpdate(prevProps) {

        if (prevProps.order.pregrader_report_form_data &&
            !this.props.order.pregrader_report_form_data) {

            this.parseData();
        }
    }

    onUpdateComment(comment) {
        this.setState(state => ({ comment }));
        this.props.updateOrderComment(comment);
    }

    onEdit() {
        this.setState(state => ({ isEdit: !state.isEdit }));
    }

    onSaveReport() {
        const { updateOrderReport, onSaveGradingReport } = this.props;
        const { formData } = this.state;

        const avgOutPercent = this.state.avgOutPercent > 55 ? this.state.avgOutPercent : 55;

        const report = [];
        const arReportData = Object.values(formData);
        const messError = this.checkReportData(formData);

        if (!messError) {
            arReportData.map((itemValue) => (
                report.push(itemValue.join(':'))
            ));

            updateOrderReport(report, avgOutPercent);

            this.setState(state => ({ isEdit: !state.isEdit }));
            onSaveGradingReport();
        }
        if (messError) {
            this.setState(state => Object.assign({}, state, {
                isModalOpen: true
            }));
        }
    }

    generateTitleCategory(dataSection, arrDataRow) {

        const arrDataContentSection = Object.values(dataSection);

        const resSumOf = arrDataContentSection.reduce((sumOf, current) => {

            const currntID = current.id;

            if (arrDataRow && !!arrDataRow[current.id]) {
                const numColumn = parseInt(arrDataRow[currntID][2], 10);

                if (numColumn >= 0 && numColumn < 4) {
                    return sumOf + parseInt(current.value[0], 10);
                } else {
                    return sumOf;
                }
            } else {
                return sumOf;
            }
        }, 0);

        const resSumOut = arrDataContentSection.reduce((sumOut, current) => {

            const currntID = current.id;

            if (arrDataRow && !!arrDataRow[currntID]) {
                const numColumn = parseInt(arrDataRow[currntID][2], 10);

                if (numColumn >= 0 && numColumn < 3) {
                    return sumOut + parseInt(current.value[numColumn], 10);
                } else {
                    return sumOut;
                }
            } else {
                return sumOut;
            }
        }, 0);

        return ({ resSumOut, resSumOf });
    }

    calcSum(newFormData) {

        const avgSectionContent = this.generateTitleCategory(dataContentSectionContent, newFormData, 'sumOutContent');
        const avgSectionStructure = this.generateTitleCategory(dataContentSectionStructure, newFormData, 'sumOutStructure');
        const avgSectionLanguage = this.generateTitleCategory(dataContentSectionLanguage, newFormData, 'sumOutLanguage');
        const avgSectionFormat = this.generateTitleCategory(dataContentSectionFormat, newFormData, 'sumOutFormat');

        const avgOf = avgSectionContent.resSumOf + avgSectionStructure.resSumOf + avgSectionLanguage.resSumOf + avgSectionFormat.resSumOf;
        const avgOut = avgSectionContent.resSumOut + avgSectionStructure.resSumOut + avgSectionLanguage.resSumOut + avgSectionFormat.resSumOut;
        const avgOutPercent = (avgOut / avgOf * 100).toFixed(0);

        // console.log('avgOutPercent: ', avgOutPercent)

        this.setState({
            formData: newFormData,
            Content: avgSectionContent,
            Structure: avgSectionStructure,
            Language: avgSectionLanguage,
            Format: avgSectionFormat,
            avgOut,
            avgOf,
            avgOutPercent,
        });

    }

    onChange(name, value) {
        const { formData } = this.state;
        let newFormData = {};

        if (!formData || !formData[name]) {
            const indexValue = value;
            const textValue = valField[value];
            const numberValue = allDataSection[name].value[value];
            const commentValue = allDataSection[name].name;

            const newDataRow = {
                [name]: [name, numberValue, indexValue, textValue, commentValue],
            };

            newFormData = { ...formData, ...newDataRow };

            this.setState({
                formData: newFormData,
            });
        }
        else {
            const indexValue = value;
            const textValue = valField[value];
            const numberValue = allDataSection[name].value[value];
            const commentValue = allDataSection[name].name;

            newFormData = {
                [name]: [name, numberValue, indexValue, textValue, commentValue],
            };

            newFormData = { ...formData, ...newFormData };
        }

        this.calcSum(newFormData);
        this.checkRatingString(newFormData);
    }

    checkReportData(formData) {
        let dataError = false;

        if (!!formData && !!formData.essay1 && formData.essay1[2] === '4') {
            dataError = '"Client requirements met" cannot be set NA';
        }

        if (!!formData &&
            (!formData.essay1 ||
            !formData.essay2 ||
            !formData.essay3 ||
            !formData.essay4 ||
            !formData.essay5 ||
            !formData.essay6 ||
            !formData.essay7 ||
            !formData.essay8 ||
            !formData.essay9 ||
            !formData.essay10 ||
            !formData.essay11)) {
            dataError = 'Please, select at least one answer before saving report';
        }

        return dataError;
    }

    checkRatingString(formData) {

        const isGradingLow =
            (!!formData.essay1 && formData.essay1[2] === '3') ||
            (!!formData.essay2 && formData.essay2[2] === '3') ||
            (!!formData.essay3 && formData.essay3[2] === '3') ||
            (!!formData.essay4 && formData.essay4[2] === '3');

        if (isGradingLow) {
            this.setState({
                avgOutPercent: 55,
            });
        }

        this.setState({
            isGradingLow
        });
    }

    getRatingString(pregraderRating) {

        let pregraderRatingStr = (<i className="text-error">55 (F)</i>);

        if (pregraderRating < 55) {
            pregraderRatingStr = (<i className="text-error">55 (F)</i>);
        }

        if (pregraderRating >= 55 && pregraderRating <= 59) {
            pregraderRatingStr = (<i className="text-error">{pregraderRating} (F)</i>);
        }

        if (pregraderRating >= 60 && pregraderRating <= 69) {
            pregraderRatingStr = (<i className="text-error">{pregraderRating} (D)</i>);
        }

        if (pregraderRating >= 70 && pregraderRating <= 79) {
            pregraderRatingStr = (<i className="text-success">{pregraderRating} (C)</i>);
        }

        if (pregraderRating >= 80 && pregraderRating <= 89) {
            pregraderRatingStr = (<i className="text-success">{pregraderRating} (B)</i>);
        }

        if (pregraderRating >= 90 && pregraderRating <= 100) {
            pregraderRatingStr = (<i className="text-success">{pregraderRating} (A)</i>);
        }

        return pregraderRatingStr;
    }

    generateDataRow(dataSection, dataRow) {
        const newdataSection = {};

        if (!!dataRow) {
            Object.values(dataRow).forEach((item) => {
                const arDataItem = item;
                const id = arDataItem[0];
                const index = arDataItem[2];

                if (id in dataSection) {
                    const data = new Array(4).fill(false);
                    newdataSection[id] = { [id]: arDataItem };
                    data[index] = true;
                    newdataSection[id] = { ...newdataSection[id], data };
                }
            });
        }

        return newdataSection;
    }

    renderData() {
        const { order, onResize, status, removeFile, uploadFile } = this.props;
        const { isEdit, formData, avgOut, avgOf, isGradingLow, isModalOpen, avgOutPercent } = this.state;

        let { Content, Structure, Language, Format } = this.state;
        const orderId = order._id;
        const hasOrderInList = !!order;
        const orderFileList = !hasOrderInList || !order.files || !order.files.items ? {} : order.files.items;
        const graderFiles = Object.values(orderFileList).filter(file => !file.deleted && (file.group === 'file_pregrader_comment' || file.type === 'file_pregrader_comment'));

        if (!Content) {
            Content = this.generateTitleCategory(dataContentSectionContent, formData);
        }

        if (!Structure) {
            Structure = this.generateTitleCategory(dataContentSectionStructure, formData);
        }

        if (!Language) {
            Language = this.generateTitleCategory(dataContentSectionLanguage, formData);
        }

        if (!Format) {
            Format = this.generateTitleCategory(dataContentSectionFormat, formData);
        }

        const avgOutSum = Content.resSumOf + Structure.resSumOf + Language.resSumOf + Format.resSumOf;

        const messError = this.checkReportData(formData);

        return (
            <div className="qa-container">

                {isModalOpen && messError && isEdit &&
                    <Modal isOpen={isModalOpen} onClose={this.toggleModal} className="modal-sm ta-center">
                        <img className="modal-icon" src={alarm} alt="" />
                        <h2 className="title mb30">{messError}</h2>
                        <button type="button" className="btn btn-bright btn-big" onClick={this.toggleModal}>Got it</button>
                    </Modal>
                }

                <div className="grade_sum">
                    {isGradingLow &&
                        <h1>
                            {/* <h1>Your grade: <span><i className="text-error">55 (F)</i> out of {avgOutSum}</span></h1> */}

                            <span className="tooltip">
                                Your grade: <i className="text-error tooltip-trigger">55 (F)</i>
                                <span className="tooltip-content">
                                    {avgOut} out of {avgOutSum}
                                </span>
                            </span>
                        </h1>
                    }

                    {!!avgOut && !!avgOf && !isGradingLow &&
                        // <h1>Your grade: <span>{this.getRatingString(avgOut)} out of {avgOutSum}</span></h1>

                        <h1>
                            <span className="tooltip">
                                Your grade: <i className="text-error tooltip-trigger">{this.getRatingString(avgOutPercent)}</i>
                                <span className="tooltip-content">
                                    {avgOut} out of {avgOutSum}
                                </span>
                            </span>
                        </h1>
                    }

                    {/* {!avgOut && !avgOf && !isGradingLow &&
                        <h1>Your grade: <span>{this.getRatingString(order.pregrader_assessing_avg)} out of {avgOutSum}</span></h1>
                    } */}
                    <div>
                        <a
                            href="/help"
                            rel="noopener noreferrer"
                            target="_blank"
                        >Grading rubric</a>

                    </div>
                </div>

                <div>
                    <EditableText
                        defaultValue={this.state.comment}
                        onTextUpdate={this.onUpdateComment}
                        placeholder="Click here to add comment"
                    />
                </div>

                <UploadReportFile
                    fileList={graderFiles}
                    uploadFile={uploadFile}
                    onResize={onResize}
                    removeFile={removeFile}
                    status={status}
                />

                <div>
                    <div className="btn-edit-group">
                        {!isEdit && status !== STATUS_COMPLETE &&
                            <div>
                                <button className="btn btn-bright btn-lg" onClick={this.onEdit}>Edit</button>
                            </div>
                        }
                        {isEdit &&
                            <div>
                                <button className="btn btn-bright btn-lg" onClick={this.onEdit}>Cancel</button>
                                <button className="btn btn-bright btn-lg" onClick={this.onSaveReport}>Save</button>
                            </div>
                        }
                    </div>

                    <div className="person_info_box">
                        <QACollapseItem
                            title="Content"
                            titleCounters={`${Content.resSumOut} out of ${Content.resSumOf}`}
                        >
                            <OrderTabQAItem
                                isEdit={isEdit}
                                orderId={orderId}
                                dataSection={dataContentSectionContent}
                                dataRow={this.generateDataRow(dataContentSectionContent, formData)}
                                onChange={this.onChange}
                                avg={order.pregrader_assessing_avg}
                            />
                        </QACollapseItem>
                    </div>
                    <div className="person_info_box">
                        <QACollapseItem
                            title="Structure"
                            titleCounters={`${Structure.resSumOut} out of ${Structure.resSumOf}`}
                        >
                            <OrderTabQAItem
                                isEdit={isEdit}
                                orderId={orderId}
                                dataSection={dataContentSectionStructure}
                                dataRow={this.generateDataRow(dataContentSectionStructure, formData)}
                                onChange={this.onChange}
                                avg={order.pregrader_assessing_avg}
                            />
                        </QACollapseItem>
                    </div>
                    <div className="person_info_box">
                        <QACollapseItem
                            title="Language"
                            titleCounters={`${Language.resSumOut} out of ${Language.resSumOf}`}
                        >
                            <OrderTabQAItem
                                isEdit={isEdit}
                                orderId={orderId}
                                dataSection={dataContentSectionLanguage}
                                dataRow={this.generateDataRow(dataContentSectionLanguage, formData)}
                                onChange={this.onChange}
                                avg={order.pregrader_assessing_avg}
                            />
                        </QACollapseItem>
                    </div>
                    <div className="person_info_box">
                        <QACollapseItem
                            title="Format"
                            titleCounters={`${Format.resSumOut} out of ${Format.resSumOf}`}
                        >
                            <OrderTabQAItem
                                isEdit={isEdit}
                                orderId={orderId}
                                dataSection={dataContentSectionFormat}
                                dataRow={this.generateDataRow(dataContentSectionFormat, formData)}
                                onChange={this.onChange}
                                avg={order.pregrader_assessing_avg}
                            />
                        </QACollapseItem>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.renderData()}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    const orderId = ownProps.order._id;
    const order = ownProps.order;

    const isLoading = order.isFetching || order.isFetchingReport;
    return { isLoading, order, orderId };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const number = ownProps.order.number;

    return {
        updateOrderReport: (report, avgOut) => dispatch(ordersQAReportFetch(number, {
            action: 'update_report',
            pregrader_report_form_data: report,
            pregrader_assessing_avg: avgOut,
        })),
        updateOrderComment: (comment) => dispatch(ordersQAReportFetch(number, {
            action: 'update_report',
            pregrader_recommendations: comment,
        }))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderTabQA);


// WEBPACK FOOTER //
// ./src/components/order/OrderTabQA.js